module.exports = global["Tether"] = require("-!D:\\www\\cre\\hsypniewski\\www\\themes\\dogo\\_dev\\node_modules\\babel-loader\\index.js!.\\tether.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/expose-loader?Tether!./node_modules/tether/dist/js/tether.js-exposed
// module id = 11
// module chunks = 0